import { isProfileHubPath } from './profileTabs';

const HUB_EXIT_KEY = 'yona.profileHub.exitPath';

/** Remember last non-hub route so × exits the hub instead of stepping back through tabs. */
export function rememberProfileHubExitPath(pathname = '', search = '') {
  if (isProfileHubPath(pathname)) return;
  const next = `${pathname || '/maps'}${search || ''}` || '/maps';
  try {
    sessionStorage.setItem(HUB_EXIT_KEY, next);
  } catch {
    // ignore (private mode / non-browser)
  }
}

export function getProfileHubExitPath(fallback = '/maps') {
  try {
    const raw = sessionStorage.getItem(HUB_EXIT_KEY);
    if (raw && typeof raw === 'string' && !isProfileHubPath(raw.split('?')[0])) {
      return raw;
    }
  } catch {
    // ignore
  }
  return fallback || '/maps';
}
